<template>
  <g transform="scale(1.4)" id="gmain">
    <Tooth
      v-for="i in tooths"
      :key="i"
      :number="i"
      :positionY="y"
      :positionX="Math.abs((i - start ) * 32) + x"
      :procedimientoSelected = "procedimientoSelected" 
      :tipoProcedimientoSelected = "tipoProcedimientoSelected"
      @diente-seleccionado="manejarDienteSeleccionado"
    />
    
  </g>
</template>

<script>
import Tooth from './Tooth.vue';

export default {
  name: 'Teeth',
  components: {
    Tooth
  },
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    },
      tipoProcedimientoSelected: {
      default:null,
      required: true
    },
      procedimientoSelected: {
      default: null,
      required: false
    }
  },
  computed: {
    tooths() {
      return this.getArray(this.start, this.end);
    }
  },
  methods: {
    manejarDienteSeleccionado(data) {
    console.log('🦷 Diente recibido del hijo:', data);

    this.$store.commit('addOrUpdateDataDiente', data);

    // Aquí puedes hacer lo que quieras con ese objeto,
    // incluso guardarlo en sessionStorage o Vuex, por ejemplo:
    //sessionStorage.setItem('ultimoDienteSeleccionado', JSON.stringify(data));
  },
    getArray(start, end) {
      const list = [];
      if (start > end) {
        for (let i = start; i >= end; i--) {
          list.push(i);
        }
      } else {
        for (let i = start; i <= end; i++) {
          list.push(i);
        }
      }
      return list;
    },
  
  }
};
</script>
